export default "__VITE_ASSET__DGgddpaL__"